export const tabletsWidth = 640;
export const desktopWidth = 980;
export const largeDesktopWidth = 1280;

export const vimeoId = 663194030;
export const appStoreUrl = 'https://apps.apple.com/us/app/gritx/id1516634763?uo=4';
export const intIosAccess = 'https://testflight.apple.com/join/S2ng3lMy';
export const googlePlayUrl = 'https://play.google.com/store/apps/details?id=com.verbalize.gritx';
// export const twitterUrl = 'https://twitter.com/GritStories/';
export const facebookUrl = 'https://www.facebook.com/JUN-Research/';
export const instagramUrl = 'https://www.instagram.com/jun_research/';
export const tiktokUrl = 'https://www.tiktok.com/@jun_research?lang=en';
export const maxArticleCards = 12;
export const maxServiceCards = 12;
export const proUser = 'GritX Pro users';
export const verbalizeStoreUser = 'Verbalize Store';
export const maxEmails = 40;
export const mainVideoUrl = 'https://verbalize-staticcontent.azureedge.net/media/GritX%20for%20Students.mp4';
export const mainVideoPosterUrl = 'https://verbalize-staticcontent.azureedge.net/media/Gritx_poster.png';
export const doiUrl = 'https://doi.org/';
export const resourceContentTypeId = 180;

export const feedbackTypes = {
  issue: 'issue',
  newContent: 'newContent',
  joinUCSF: 'joinUCSF',
  shareHistory: 'shareHistory',
  chat: 'chat',
  newsletter: 'newsletter'
};

export const emailRegExp = new RegExp(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/);
export const fileSize = 10485760;

export enum ContentType {
  Meditation = 'MEDITATION',
  Skill = 'SKILL',
  SelfCare = 'Self-care',
  Journal = 'JOURNAL',
  SelfInterview = 'SELF_INTERVIEW'
}

export enum SystemLanguage {
  English = 'en',
  Spanish = 'es',
  Chinese = 'zh',
  French = 'fr',
  German = 'de',
  Hindi = 'hi',
  Malayalam = 'ml',
  Portuguese = 'pt',
  Filipino = 'fil',
  Tamil = 'ta',
  Vietnamese = 'vi',
  Japanese = 'ja',
  Dari = 'prs',
  Pashto = 'ps',
  Korean = 'ko'
}

export const languages = [
  {
    value: SystemLanguage.English,
    title: 'English',
    key: 'gritx.common.language.en'
  },
  {
    value: SystemLanguage.Spanish,
    title: 'Spanish',
    key: 'gritx.common.language.es'
  },
  {
    value: SystemLanguage.Chinese,
    title: 'Chinese',
    key: 'gritx.common.language.zh'
  },
  {
    value: SystemLanguage.French,
    title: 'French',
    key: 'gritx.common.language.fr'
  },
  {
    value: SystemLanguage.Japanese,
    title: 'Japanese',
    key: 'gritx.common.language.ja'
  },
  {
    value: SystemLanguage.Dari,
    title: 'Dari',
    key: 'gritx.common.language.prs'
  },
  {
    value: SystemLanguage.Pashto,
    title: 'Pashto',
    key: 'gritx.common.language.ps'
  },
  {
    value: SystemLanguage.Korean,
    title: 'Korean',
    key: 'gritx.common.language.ko'
  }
];

